import { isEqual } from 'lodash';
import memoizeOne from 'memoize-one';

export const memoize = <TMethod extends (...args: Array<any>) => any>( // tslint:disable-line:no-any
  method: TMethod,
): TMethod => memoizeOne(method, isEqual);
